import { render, staticRenderFns } from "./page012.vue?vue&type=template&id=ccdd9976&scoped=true&"
import script from "./page012.vue?vue&type=script&lang=js&"
export * from "./page012.vue?vue&type=script&lang=js&"
import style0 from "./page012.vue?vue&type=style&index=0&id=ccdd9976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdd9976",
  null
  
)

export default component.exports